/** Theme customiser and page builder. Conventions: see `common.ts`. */
const themeEditor: Record<string, string> = {
  'language_switcher.title': 'Language selector',
  'language_switcher.show': 'Show a language selector',
  'language_switcher.show_hint':
    'Only appears when your shop is published in more than one language and switching is on under Settings → Languages.',
  'language_switcher.placements': 'Where it appears',
  'language_switcher.placement.header': 'In the header',
  'language_switcher.placement.footer': 'In the footer',
  'language_switcher.placement.mobile': 'In the mobile menu',
  'language_switcher.display': 'Show languages as',
  'language_switcher.display.native': 'Their own name (हिन्दी)',
  'language_switcher.display.name': 'English name (Hindi)',
  'language_switcher.display.code': 'Code (HI)',
  'language_switcher.display.native_code': 'Own name and code (हिन्दी (HI))',
  'language_switcher.display.theme': 'As the theme shows them',
  'language_switcher.no_flags':
    'Languages are named in words, never flags: a flag is a country, not a language.',
  'section.language_selector.title': 'Heading',
  // --- Section types ---
  'section_groups.commerce': 'Commerce',
  'section_groups.marketing': 'Marketing',
  'section_groups.content': 'Content',
  'section_groups.forms': 'Forms',
  'section_groups.page': 'The page itself',
  'sections.hero.label': 'Hero banner',
  'sections.hero.description': 'A full-width welcome with a headline, one button, and a picture or a few to cycle through.',
  'sections.slideshow.label': 'Slideshow',
  'sections.slideshow.description': 'Several banners that rotate. One slide per campaign.',
  'sections.slideshow.block': 'Slide',
  'sections.featured_products.label': 'Product grid',
  'sections.featured_products.description': 'A row of products, all of them or one category.',
  'sections.recently_viewed.label': 'Recently viewed',
  'sections.recently_viewed.description':
    'The products each shopper looked at lately. Hidden until they have looked at some.',
  'sections.product_tabs.label': 'Product tabs',
  'sections.product_tabs.description': 'New arrivals, best sellers, on sale or a category - one product row, a tab for each.',
  'sections.product_tabs.block': 'Tab',
  'sections.categories.label': 'Category grid',
  'sections.categories.description': 'Ways into the catalog, by category.',
  'sections.category_strip.label': 'Category strip',
  'sections.category_strip.description': 'One thin row of small icons linking to your categories, usually just under the header. Slides sideways on phones.',
  'sections.image_with_text.label': 'Image with text',
  'sections.image_with_text.description': 'A picture beside a paragraph. Good for your story.',
  'sections.gallery.label': 'Image gallery',
  'sections.gallery.description': 'A grid of photographs, each one optionally a link.',
  'sections.gallery.block': 'Image',
  'sections.promo_grid.label': 'Promo tiles',
  'sections.promo_grid.description': 'A mosaic of offer tiles - "Up to 50% off headphones" - each with a picture or a colour, and a link.',
  'sections.promo_grid.block': 'Tile',
  'sections.brand_strip.label': 'Shop by brand',
  'sections.brand_strip.description': 'A row of brand logos. With none uploaded, the brands on your products are shown by name.',
  'sections.brand_strip.block': 'Brand',
  'sections.lookbook.label': 'Shop the look',
  'sections.lookbook.description': 'A styled photo with your products tagged on it. Shoppers tap a dot to see the product and its price.',
  'sections.lookbook.block': 'Hotspot',
  'sections.before_after.label': 'Before and after',
  'sections.before_after.description': 'Two photos of the same thing with a slider between them - great for results, cleaning or makeovers.',
  'sections.video.label': 'Video',
  'sections.video.description': 'A YouTube video or a file of your own, in a player shoppers can play, pause, seek and expand.',
  'sections.social_links.label': 'Social media links',
  'sections.social_links.description': 'Instagram, Facebook, YouTube, WhatsApp, X, LinkedIn and Pinterest, as a row of their own icons. Paste an address and its icon appears.',
  'sections.social_links.block': 'Link',
  'sections.features.label': 'Promises strip',
  'sections.features.description': 'Delivery, returns, payments - what you offer, with icons. Or big figures, like 15+ years.',
  'sections.features.block': 'Promise',
  'sections.testimonials.label': 'Customer reviews',
  'sections.testimonials.description': 'Quotes from real customers, with a rating.',
  'sections.testimonials.block': 'Review',
  'sections.faq.label': 'Questions & answers',
  'sections.faq.description': 'The questions shoppers ask before they buy.',
  'sections.faq.block': 'Question',
  'sections.timeline.label': 'Timeline',
  'sections.timeline.description': 'Your story in dated steps - when you opened, how you grew, where you are today.',
  'sections.timeline.block': 'Milestone',
  'sections.text.label': 'Text',
  'sections.text.description': 'A block of formatted writing on its own.',
  'sections.link_directory.label': 'Link directory',
  'sections.link_directory.description':
    'Rows of small text links under short headings - popular searches or every sub-category. Fills itself from your categories, or type your own groups.',
  'sections.link_directory.block': 'Link group',
  'sections.banner.label': 'Announcement',
  'sections.banner.description': 'A single line across the page - a sale, a notice, a deadline.',
  'sections.contact_form.label': 'Contact form',
  'sections.contact_form.description': 'Let shoppers write to you. Messages arrive by email.',
  'sections.newsletter.label': 'Email signup',
  'sections.newsletter.description': 'Collect email addresses for your marketing.',
  'sections.countdown.label': 'Countdown timer',
  'sections.countdown.description': 'A ticking clock to the end of a sale, with a button to shop it. Hides itself when time is up.',
  'sections.blog_posts.label': 'Blog posts',
  'sections.blog_posts.description': 'Your newest blog posts, as cards, a list or one lead story. Hidden while there are none.',
  'sections.bookings.label': 'Bookings & appointments',
  'sections.bookings.description': 'Your services, your free times, and a form that takes the booking. For clinics, salons, spas and consultants.',
  'sections.bookings.block': 'Service',
  'sections.store_locator.label': 'Store locator',
  'sections.store_locator.description': 'Your shops people can walk into: addresses, opening hours, "open now" and directions. Hidden until you add a location.',
  'sections.team.label': 'Team',
  'sections.team.description': 'Your doctors, stylists or consultants, with a profile page each and a button to book them. Hidden until you add someone.',
  'sections.careers.label': 'Careers',
  'sections.careers.description': 'Your newest open positions, with a link to your Careers page. Hidden until you add a role and turn the Careers page on.',
  'sections.product_reviews.label': 'Product reviews',
  'sections.product_reviews.description': 'Star ratings and reviews from customers who bought the product, with a form to write one. For the product page.',
  'sections.language_selector.label': 'Language selector',
  'sections.language_selector.description': 'Let shoppers read your shop in another language. Hidden while the shop has only one.',
  'sections.product_details.label': 'Product details',
  'sections.product_details.description': 'The product itself: its pictures, price, options and buy button, laid out the way this theme lays them out.',
  'sections.product_list.label': 'Product listing',
  'sections.product_list.description': 'The catalog grid, its category filter and its pages.',
  'sections.category_list.label': 'Category listing',
  'sections.category_list.description': 'Every shelf in the shop, as a grid of tiles.',
  'sections.search_results.label': 'Search results',
  'sections.search_results.description': 'What a shopper found, with the facets they narrow it by.',
  'sections.cart_lines.label': 'Cart',
  'sections.cart_lines.description': 'The basket: its lines, its discount box and its totals.',
  'sections.checkout_form.label': 'Checkout',
  'sections.checkout_form.description': 'The address and payment form, with the order summary beside it.',
  'sections.customer_login.label': 'Sign in',
  'sections.customer_login.description': 'The shopper’s sign-in form, with whatever you put around it.',
  'sections.customer_register.label': 'Create an account',
  'sections.customer_register.description': 'The registration form, and the case for having an account.',
  'sections.customer_account.label': 'Account',
  'sections.customer_account.description': 'A signed-in shopper’s own page: their orders, addresses and details.',
  'sections.blog_index.label': 'Blog',
  'sections.blog_index.description': 'Your posts, newest first.',
  'sections.blog_post.label': 'Blog post',
  'sections.blog_post.description': 'One post, as a reader meets it.',
  'sections.not_found.label': 'Page not found',
  'sections.not_found.description': 'The dead end, and the way you offer back into the shop.',
  'sections.team_member_details.label': 'Team member profile',
  'sections.team_member_details.description': 'One person: their photo, role, qualifications, hours, services and a button to book them.',
  // --- Pages ---
  'page_groups.home': 'Home',
  'page_groups.catalog': 'Catalog',
  'page_groups.product': 'Product',
  'page_groups.shopping': 'Shopping',
  'page_groups.customer': 'Customer',
  'page_groups.content': 'Content',
  'page_groups.system': 'System',
  'pages.home.label': 'Home page',
  'pages.home.description': 'The front door. Everything on it is yours to arrange.',
  'pages.product.label': 'Product page',
  'pages.product.description': 'One product: its pictures, its price and its buy button.',
  'pages.listing.label': 'Product listing',
  'pages.listing.description': 'The catalog, and one category seen through a filter.',
  'pages.category.label': 'Category listing',
  'pages.category.description': 'The shelves of the shop, as a way in for a shopper who is browsing.',
  'pages.search.label': 'Search results',
  'pages.search.description': 'What a shopper found, and the facets they narrow it by.',
  'pages.cart.label': 'Cart',
  'pages.cart.description': 'The basket, on its way to the till.',
  'pages.checkout.label': 'Checkout',
  'pages.checkout.description': 'Address, payment and the order summary. Add reassurance around it.',
  'pages.login.label': 'Sign in',
  'pages.login.description': 'A returning shopper, on their way back to their orders.',
  'pages.register.label': 'Create an account',
  'pages.register.description': 'Where you make the case for keeping their details.',
  'pages.account.label': 'Account',
  'pages.account.description': 'A signed-in shopper’s own page - orders, addresses, details.',
  'pages.blog.label': 'Blog',
  'pages.blog.description': 'Your writing, newest first.',
  'pages.post.label': 'Blog post',
  'pages.post.description': 'One post. What stands under it is where readers become shoppers.',
  'pages.notFound.label': 'Page not found',
  'pages.notFound.description': 'A dead end. Offer a way back in rather than an apology.',
  'pages.team_member.label': 'Team member profile',
  'pages.team_member.description': 'One person: who they are, when they work, and a button to book them.',
  // --- Regions ---
  'regions.product_details.top.label': 'Above the product',
  'regions.product_details.top.description': 'Full width, over both columns - where a breadcrumb or a notice stands.',
  'regions.product_details.main.label': 'Buy column',
  'regions.product_details.main.description': 'Beside the pictures: the name, the price and the way into the basket.',
  'regions.product_details.gallery.label': 'Gallery column',
  'regions.product_details.gallery.description': 'The pictures, and anything you want read alongside them.',
  'regions.product_details.below.label': 'Below the product',
  'regions.product_details.below.description': 'Full width, under both columns.',
  'regions.product_list.top.label': 'Above the catalog',
  'regions.product_list.top.description': 'The heading and the filters.',
  'regions.product_list.main.label': 'The catalog',
  'regions.product_list.main.description': 'The grid of products and its pages.',
  'regions.product_list.below.label': 'Below the catalog',
  'regions.product_list.below.description': 'Under the grid, full width.',
  'regions.category_list.top.label': 'Above the shelves',
  'regions.category_list.top.description': 'The heading.',
  'regions.category_list.main.label': 'The shelves',
  'regions.category_list.main.description': 'The grid of categories.',
  'regions.category_list.below.label': 'Below the shelves',
  'regions.category_list.below.description': 'Under the grid.',
  'regions.search_results.top.label': 'Above the results',
  'regions.search_results.top.description': 'The heading, the count and the sort.',
  'regions.search_results.facets.label': 'Facet panel',
  'regions.search_results.facets.description': 'The rail a shopper narrows results with.',
  'regions.search_results.main.label': 'The results',
  'regions.search_results.main.description': 'The grid of matches and its pages.',
  'regions.search_results.below.label': 'Below the results',
  'regions.search_results.below.description': 'Under the grid.',
  'regions.cart_lines.top.label': 'Above the basket',
  'regions.cart_lines.top.description': 'Full width, over both columns.',
  'regions.cart_lines.main.label': 'The lines',
  'regions.cart_lines.main.description': 'What is in the cart.',
  'regions.cart_lines.summary.label': 'Totals panel',
  'regions.cart_lines.summary.description': 'Beside the lines: the money and the way out.',
  'regions.cart_lines.below.label': 'Below the basket',
  'regions.cart_lines.below.description': 'Under both, full width.',
  'regions.checkout_form.top.label': 'Above the till',
  'regions.checkout_form.top.description': 'Full width, over both columns.',
  'regions.checkout_form.main.label': 'The form',
  'regions.checkout_form.main.description': 'Address, delivery and payment.',
  'regions.checkout_form.summary.label': 'Order summary',
  'regions.checkout_form.summary.description': 'Beside the form: what is being bought.',
  'regions.checkout_form.below.label': 'Below the till',
  'regions.checkout_form.below.description': 'Under both, full width.',
  'regions.customer_login.main.label': 'The page',
  'regions.customer_login.main.description': 'The sign-in form and its words.',
  'regions.customer_register.main.label': 'The page',
  'regions.customer_register.main.description': 'The registration form and its words.',
  'regions.customer_account.main.label': 'The page',
  'regions.customer_account.main.description': 'A shopper\'s own page.',
  'regions.blog_index.main.label': 'The page',
  'regions.blog_index.main.description': 'The list of posts.',
  'regions.blog_post.main.label': 'The page',
  'regions.blog_post.main.description': 'One post.',
  'regions.not_found.main.label': 'The page',
  'regions.not_found.main.description': 'The dead end.',
  'regions.team_member_details.main.label': 'The page',
  'regions.team_member_details.main.description': 'One person.',
  // --- Page components (parts) ---
  'part_groups.essential': 'The page itself',
  'part_groups.detail': 'Details',
  'part_groups.action': 'Buttons and choices',
  'part_groups.money': 'Money',
  'part_groups.discovery': 'More to find',
  'part_groups.custom': 'Your own',
  'parts.custom_heading.label': 'Heading',
  'parts.custom_heading.description': 'A line of your own, in the shop\'s heading face.',
  'parts.custom_heading.options.level.label': 'Heading level',
  'parts.custom_heading.options.level.hint': 'What it means to a screen reader and to a search engine.',
  'parts.custom_heading.options.level.choices.h2': 'Section heading (h2)',
  'parts.custom_heading.options.level.choices.h3': 'Sub-heading (h3)',
  'parts.custom_heading.options.level.choices.p': 'Not a heading',
  'parts.custom_text.label': 'Text',
  'parts.custom_text.description': 'A paragraph of your own - a promise, a note, a warning.',
  'parts.custom_button.label': 'Button',
  'parts.custom_button.description': 'A link that looks like a button - a size guide, a contact page.',
  'parts.custom_button.options.href.label': 'Links to',
  'parts.custom_button.options.href.placeholder': '/pages/size-guide',
  'parts.custom_button.options.style.label': 'Style',
  'parts.custom_button.options.style.choices.solid': 'Filled',
  'parts.custom_button.options.style.choices.outline': 'Outlined',
  'parts.custom_button.options.style.choices.link': 'A plain link',
  'parts.custom_button.options.new_tab.label': 'Open in a new tab',
  'parts.custom_button.options.new_tab.hint': 'For an address away from your shop.',
  'parts.custom_image.label': 'Image',
  'parts.custom_image.description': 'A picture of your own - a size chart, a badge, a care label.',
  'parts.custom_image.options.image_url.label': 'Image',
  'parts.custom_image.options.alt.label': 'Alt text',
  'parts.custom_image.options.alt.hint': 'What it shows, for a shopper who cannot see it.',
  'parts.custom_image.options.href.label': 'Links to',
  'parts.custom_image.options.href.placeholder': '/pages/size-guide',
  'parts.custom_image.options.max_width.label': 'Widest it gets',
  'parts.custom_image.options.max_width.hint': 'In pixels. Zero leaves it to the column.',
  'parts.divider.label': 'Divider',
  'parts.divider.description': 'A hairline rule, for separating one thing from the next.',
  'parts.spacer.label': 'Space',
  'parts.spacer.description': 'Empty room, when two things are standing too close.',
  'parts.spacer.options.height.label': 'Height',
  'parts.spacer.options.height.hint': 'In pixels.',
  'parts.product_breadcrumbs.label': 'Breadcrumbs',
  'parts.product_breadcrumbs.description': 'Where the shopper is: the way back to the shop, and to the catalog.',
  'parts.product_breadcrumbs.options.home_label.label': 'First rung',
  'parts.product_breadcrumbs.options.home_label.placeholder': 'Home',
  'parts.product_breadcrumbs.options.catalog_label.label': 'Second rung',
  'parts.product_breadcrumbs.options.catalog_label.hint': 'Leave it blank to go straight from the shop to this product.',
  'parts.product_breadcrumbs.options.catalog_label.placeholder': 'All products',
  'parts.product_breadcrumbs.options.show_current.label': 'End on the product’s name',
  'parts.product_gallery.label': 'Product images',
  'parts.product_gallery.description': 'The pictures, and the strip that picks between them.',
  'parts.product_gallery.options.aspect.label': 'Picture shape',
  'parts.product_gallery.options.aspect.choices.theme': 'The theme\'s own',
  'parts.product_gallery.options.aspect.choices.square': 'Square',
  'parts.product_gallery.options.aspect.choices.portrait': 'Portrait',
  'parts.product_gallery.options.aspect.choices.wide': 'Wide',
  'parts.product_gallery.options.thumbs.label': 'Thumbnails',
  'parts.product_gallery.options.thumbs.choices.theme': 'The theme\'s own',
  'parts.product_gallery.options.thumbs.choices.below': 'Under the picture',
  'parts.product_gallery.options.thumbs.choices.rail': 'In a rail beside it',
  'parts.product_gallery.options.rounded.label': 'Rounded corners',
  'parts.product_gallery.options.style.label': 'Layout',
  'parts.product_gallery.options.style.hint': 'One picture with a strip keeps the thumbnails setting below; the others decide it themselves.',
  'parts.product_gallery.options.style.choices.carousel': 'One picture with a strip',
  'parts.product_gallery.options.style.choices.thumbs_left': 'Thumbnail rail on the left',
  'parts.product_gallery.options.style.choices.thumbs_bottom': 'Thumbnails underneath',
  'parts.product_gallery.options.style.choices.grid': 'Every picture, two to a row',
  'parts.product_gallery.options.sticky.label': 'Stay in view while the page scrolls',
  'parts.product_gallery.options.sticky.hint': 'On a computer screen only. A phone shows the pictures above everything else.',
  'parts.product_brand.label': 'Brand',
  'parts.product_brand.description': 'The maker\'s name, above the product\'s own.',
  'parts.product_title.label': 'Product title',
  'parts.product_title.description': 'The product\'s name. The page\'s one h1.',
  'parts.product_price.label': 'Price',
  'parts.product_price.description': 'What the chosen variant costs, and what it used to.',
  'parts.product_price.options.show_compare_at.label': 'Show the was-price beside it',
  'parts.product_price.options.show_saving.label': 'Show what they save',
  'parts.product_price.options.show_saving.hint': 'A "Save 20%" beside the price, whenever there is a was-price to compare with.',
  'parts.product_compare_price.label': 'Compare-at price',
  'parts.product_compare_price.description': 'The was-price on its own, for putting somewhere else on the page.',
  'parts.product_compare_price.options.show_label.label': 'Show a word before it',
  'parts.product_tax_note.label': 'Tax note',
  'parts.product_tax_note.description': 'The line under the price about what is included.',
  'parts.product_sku.label': 'SKU',
  'parts.product_sku.description': 'The chosen variant\'s code, for a shopper who is ordering by it.',
  'parts.product_availability.label': 'Availability',
  'parts.product_availability.description': 'Whether the chosen variant is in stock.',
  'parts.product_availability.options.in_stock_text.label': 'When it is in stock',
  'parts.product_availability.options.in_stock_text.placeholder': 'In stock',
  'parts.product_availability.options.out_of_stock_text.label': 'When it is not',
  'parts.product_availability.options.out_of_stock_text.placeholder': 'Out of stock',
  'parts.product_availability.options.show_dot.label': 'Show a coloured dot',
  'parts.product_short_description.label': 'Summary',
  'parts.product_short_description.description': 'The product\'s one-line summary, above the options.',
  'parts.product_highlights.label': 'Highlights',
  'parts.product_highlights.description': 'A row of short claims beside the price - "Eco-certified", "15-year warranty".',
  'parts.product_highlights.options.style.label': 'Shown as',
  'parts.product_highlights.options.style.choices.chips': 'Outlined chips',
  'parts.product_highlights.options.style.choices.ticks': 'A ticked list',
  'parts.product_highlights.options.style.choices.icons': 'Icons over small labels',
  'parts.product_variants.label': 'Options',
  'parts.product_variants.description': 'Size, colour - the choice a shopper makes before buying.',
  'parts.product_variants.options.style.label': 'Shown as',
  'parts.product_variants.options.style.choices.buttons': 'Buttons, one per combination',
  'parts.product_variants.options.style.choices.axes': 'One row per option',
  'parts.product_variants.options.style.choices.swatches': 'One row per option, colours as dots',
  'parts.product_variants.options.style.choices.dropdown': 'A dropdown',
  'parts.product_variants.options.hide_sold_out.label': 'Hide sold-out options',
  'parts.product_quantity.label': 'Quantity',
  'parts.product_quantity.description': 'How many, for a shop where people buy more than one.',
  'parts.product_quantity.options.max.label': 'Most they may buy at once',
  'parts.product_add_to_cart.label': 'Add to cart',
  'parts.product_add_to_cart.description': 'The button that puts the chosen variant in the basket.',
  'parts.product_buy_now.label': 'Buy now',
  'parts.product_buy_now.description': 'Straight to the till, for a shopper who has already decided.',
  'parts.product_buy_now.options.style.label': 'Style',
  'parts.product_buy_now.options.style.choices.outline': 'Outlined',
  'parts.product_buy_now.options.style.choices.solid': 'Filled',
  'parts.product_buy_on_whatsapp.label': 'Buy on WhatsApp',
  'parts.product_buy_on_whatsapp.description': 'A chat with you about this product, opened with it already named.',
  'parts.product_buy_on_whatsapp.options.show_icon.label': 'Show the WhatsApp mark',
  'parts.product_description.label': 'Description',
  'parts.product_description.description': 'The product\'s full description.',
  'parts.product_description.options.show_heading.label': 'Show a heading over it',
  'parts.product_description.options.collapsible.label': 'Fold it away',
  'parts.product_description.options.collapsible.hint': 'A long description opens on a click rather than filling the page.',
  'parts.product_specs.label': 'Specifications',
  'parts.product_specs.description': 'The product\'s own fields - materials, dimensions, whatever you record.',
  'parts.product_shipping_info.label': 'Delivery and returns',
  'parts.product_shipping_info.description': 'What you promise about getting it there, and about sending it back.',
  'parts.product_shipping_info.options.collapsible.label': 'Fold it away',
  'parts.product_shipping_info.options.icon.label': 'Icon',
  'parts.product_shipping_info.options.icon.choices.none': 'None',
  'parts.product_shipping_info.options.icon.choices.truck': 'Delivery van',
  'parts.product_shipping_info.options.icon.choices.return': 'Returns arrow',
  'parts.product_shipping_info.options.icon.choices.shield': 'Shield',
  'parts.product_shipping_info.options.icon.choices.clock': 'Clock',
  'parts.product_payment.label': 'Payment and security',
  'parts.product_payment.description': 'What you take, and the line about what happens to a card.',
  'parts.product_payment.options.methods.label': 'What you take',
  'parts.product_payment.options.methods.hint': 'Separated by commas. Each becomes one chip. Names rather than logos - a scheme’s mark is its own trademark.',
  'parts.product_payment.options.methods.placeholder': 'Visa, Mastercard, UPI',
  'parts.product_payment.options.collapsible.label': 'Fold it away',
  'parts.product_share.label': 'Share',
  'parts.product_share.description': 'Ways for a shopper to pass this page on.',
  'parts.product_share.options.facebook.label': 'Facebook',
  'parts.product_share.options.x.label': 'X',
  'parts.product_share.options.whatsapp.label': 'WhatsApp',
  'parts.product_share.options.copy_link.label': 'A link to this page',
  'parts.product_related.label': 'Related products',
  'parts.product_related.description': 'Similar things, and what else sold alongside this.',
  'parts.product_recommendations.label': 'Recommended for you',
  'parts.product_recommendations.description': 'Chosen from this shopper\'s own history.',
  'parts.product_comparison.label': 'Compare with similar',
  'parts.product_comparison.description': 'This product beside its neighbours: price, options, maker, availability.',
  'parts.product_comparison.options.columns.label': 'Products in the table',
  'parts.product_comparison.options.columns.hint': 'Including this one. A table a shopper scrolls sideways twice is a catalogue.',
  'parts.product_comparison.options.show_description.label': 'The summary row',
  'parts.product_comparison.options.show_options.label': 'The options row',
  'parts.product_comparison.options.show_brand.label': 'The maker row',
  'parts.product_comparison.options.show_availability.label': 'The availability row',
  'parts.product_accordion.label': 'Accordion',
  'parts.product_accordion.description': 'Folding panels - ingredients, how to use, care - each opened with a tap.',
  'parts.product_accordion.options.include_specs.label': 'Include the product\'s specifications',
  'parts.product_accordion.options.include_specs.hint': 'Each specification with a value becomes a panel, before your own.',
  'parts.product_accordion.options.first_open.label': 'Open the first panel',
  'parts.product_accordion.options.single_open.label': 'One panel open at a time',
  'parts.product_accordion.options.single_open.hint': 'Opening a panel closes the one that was open.',
  'parts.product_delivery_estimate.label': 'Delivery date check',
  'parts.product_delivery_estimate.description': 'A PIN code box that answers when it would arrive, and whether cash on delivery is offered there.',
  'parts.product_delivery_estimate.options.show_cod.label': 'Say whether cash on delivery is offered',
  'parts.product_delivery_estimate.options.min_days.label': 'Fewest days to deliver',
  'parts.product_delivery_estimate.options.min_days.hint': 'Days to pack plus days on the road. Used only where your delivery settings give no date.',
  'parts.product_delivery_estimate.options.max_days.label': 'Most days to deliver',
  'parts.product_delivery_estimate.options.max_days.hint': 'The far end of the same range.',
  'parts.product_stock_bar.label': 'Low-stock bar',
  'parts.product_stock_bar.description': '"Only 4 left", with a bar that empties - shown only when stock runs low.',
  'parts.product_stock_bar.options.threshold.label': 'Show it at or below',
  'parts.product_stock_bar.options.threshold.hint': 'Pieces left. Above this, and on products whose stock you do not track, it shows nothing.',
  'parts.product_stock_bar.options.style.label': 'Shown as',
  'parts.product_stock_bar.options.style.choices.bar': 'Words over a bar',
  'parts.product_stock_bar.options.style.choices.text': 'Words only',
  'parts.product_offers.label': 'Offers and codes',
  'parts.product_offers.description': 'Your discount codes beside the price, each with a button that copies it.',
  'parts.product_offers.options.show_copy.label': 'A copy button beside each code',
  'parts.product_sticky_cart.label': 'Sticky add-to-cart bar',
  'parts.product_sticky_cart.description': 'A bar along the bottom of the screen with the name, the price and the button, once the main button scrolls away.',
  'parts.product_sticky_cart.options.show_on.label': 'Show it on',
  'parts.product_sticky_cart.options.show_on.choices.mobile': 'Phones only',
  'parts.product_sticky_cart.options.show_on.choices.all': 'Every screen',
  'parts.product_sticky_cart.options.show_image.label': 'Show the first picture',
  'parts.product_size_chart.label': 'Size chart',
  'parts.product_size_chart.description': 'A "Size chart" link that opens your measurements table, a picture of it, or both.',
  'parts.product_size_chart.options.image_url.label': 'Picture of the chart',
  'parts.product_size_chart.options.note.label': 'Line under the table',
  'parts.product_size_chart.options.note.placeholder': 'Measurements are of the garment, in inches.',
  'parts.product_bundle.label': 'Frequently bought together',
  'parts.product_bundle.description': 'This product and the ones you bundle with it, joined with +, the price of the set and one "Add all to cart" button.',
  'parts.product_bundle.options.show_checkboxes.label': 'Let them untick items',
  'parts.product_bundle.options.show_checkboxes.hint': 'The bundle discount still needs every item in the cart.',
  'parts.product_bundle.options.layout.label': 'Laid out as',
  'parts.product_bundle.options.layout.choices.row': 'Pictures in a row',
  'parts.product_bundle.options.layout.choices.list': 'A list',
  'parts.product_qa.label': 'Questions and answers',
  'parts.product_qa.description': "Customers' questions about the product with your answers, and a form to ask one.",
  'parts.product_qa.options.page_size.label': 'Questions shown at first',
  'parts.product_qa.options.page_size.hint': 'More load with a button underneath.',
  'parts.product_qa.options.allow_questions.label': 'Let customers ask questions',
  'parts.product_qa.options.show_ask_button.label': 'Keep the form behind an "Ask a question" button',
  'parts.product_qa.options.show_ask_button.hint': 'Off shows the form open under the questions.',
  'parts.product_notify_me.label': 'Notify me when available',
  'parts.product_notify_me.description': 'An email box shown only while the chosen option is sold out, so the customer hears when it is back.',
  'parts.product_notify_me.options.hide_add_to_cart.label': 'Hide the add-to-cart button while sold out',
  'parts.product_notify_me.options.hide_add_to_cart.hint': 'Off keeps the greyed-out button above this box.',
  'parts.product_seller_info.label': 'Seller information',
  'parts.product_seller_info.description': 'A bordered panel with your legal name, address, GSTIN or FSSAI number and customer care, from Settings > Business. Shows only once you switch on "Show seller details on product pages".',
  'part_hints.product_seller_info': 'Your legal name, address, GSTIN/FSSAI and customer care appear here. Fill them in under Settings > Business and switch on "Show seller details on product pages".',
  'parts.cart_heading.label': 'Cart heading',
  'parts.cart_heading.description': 'The words at the top of the basket.',
  'parts.cart_items.label': 'Cart items',
  'parts.cart_items.description': 'The lines: picture, name, quantity and line total.',
  'parts.cart_items.options.show_image.label': 'Show pictures',
  'parts.cart_items.options.show_options.label': 'Show the variant under the name',
  'parts.cart_items.options.allow_quantity.label': 'Let them change the quantity',
  'parts.cart_items.options.allow_remove.label': 'Let them remove a line',
  'parts.cart_continue_link.label': 'Keep shopping link',
  'parts.cart_continue_link.description': 'The way back into the shop from an empty basket.',
  'parts.cart_summary_heading.label': 'Summary heading',
  'parts.cart_summary_heading.description': 'The words over the totals.',
  'parts.cart_subtotal.label': 'Subtotal',
  'parts.cart_subtotal.description': 'What the lines come to before anything else.',
  'parts.cart_discount.label': 'Discount row',
  'parts.cart_discount.description': 'What a code took off. Shows only when one is applied.',
  'parts.cart_tax.label': 'Tax row',
  'parts.cart_tax.description': 'The tax on the order.',
  'parts.cart_shipping.label': 'Delivery row',
  'parts.cart_shipping.description': 'What delivery costs, once it is known.',
  'parts.cart_total.label': 'Total',
  'parts.cart_total.description': 'The number the shopper is agreeing to.',
  'parts.cart_coupon.label': 'Discount code',
  'parts.cart_coupon.description': 'The box a shopper types a code into.',
  'parts.cart_coupon.options.button_label.label': 'Button',
  'parts.cart_coupon.options.button_label.placeholder': 'Apply',
  'parts.cart_checkout_button.label': 'Checkout button',
  'parts.cart_checkout_button.description': 'The way out of the basket and into the till.',
  'parts.cart_recommendations.label': 'Recommended for you',
  'parts.cart_recommendations.description': 'What else this shopper might still be looking for.',
  'parts.cart_note.label': 'Order notes',
  'parts.cart_note.description': 'A box where the shopper writes instructions for the order.',
  'parts.cart_note.options.placeholder.label': 'Hint inside the box',
  'parts.cart_note.options.placeholder.placeholder': 'Delivery or gift notes',
  'parts.cart_note.options.max_length.label': 'Longest note',
  'parts.cart_note.options.max_length.hint': 'In characters, up to 1000.',
  'parts.checkout_heading.label': 'Checkout heading',
  'parts.checkout_heading.description': 'The words at the top of the till.',
  'parts.checkout_fields.label': 'Checkout form',
  'parts.checkout_fields.description': 'Address, delivery and payment. The fields themselves are fixed.',
  'parts.checkout_summary_heading.label': 'Summary heading',
  'parts.checkout_summary_heading.description': 'The words over what is being bought.',
  'parts.checkout_summary_items.label': 'Order lines',
  'parts.checkout_summary_items.description': 'What is in the order, listed beside the form.',
  'parts.checkout_summary_items.options.show_image.label': 'Show pictures',
  'parts.checkout_subtotal.label': 'Subtotal',
  'parts.checkout_subtotal.description': 'What the lines come to.',
  'parts.checkout_discount.label': 'Discount row',
  'parts.checkout_discount.description': 'What a code took off.',
  'parts.checkout_tax.label': 'Tax row',
  'parts.checkout_tax.description': 'The tax on the order.',
  'parts.checkout_shipping.label': 'Delivery row',
  'parts.checkout_shipping.description': 'What delivery costs.',
  'parts.checkout_total.label': 'Total',
  'parts.checkout_total.description': 'The number being charged.',
  'parts.checkout_coupon.label': 'Discount code',
  'parts.checkout_coupon.description': 'The box a shopper types a code into at the till.',
  'parts.checkout_gift_card.label': 'Gift card',
  'parts.checkout_gift_card.description': 'The box a shopper pays with a gift card from.',
  'parts.checkout_place_order.label': 'Place order button',
  'parts.checkout_place_order.description': 'The last button in the shop.',
  'parts.listing_heading.label': 'Catalog heading',
  'parts.listing_heading.description': 'The words at the top. A category being browsed keeps its own name.',
  'parts.listing_refine_link.label': 'Refine link',
  'parts.listing_refine_link.description': 'The way from browsing into searching.',
  'parts.listing_banner.label': 'Category banner',
  'parts.listing_banner.description': "The category's own picture and description above the products - or words and a picture of your own.",
  'parts.listing_banner.options.layout.label': 'Layout',
  'parts.listing_banner.options.layout.choices.split': 'Picture beside the words',
  'parts.listing_banner.options.layout.choices.overlay': 'Words over the picture',
  'parts.listing_banner.options.layout.choices.text': 'Words only',
  'parts.listing_banner.options.height.label': 'Height',
  'parts.listing_banner.options.height.choices.sm': 'Short',
  'parts.listing_banner.options.height.choices.md': 'Medium',
  'parts.listing_banner.options.height.choices.lg': 'Tall',
  'parts.listing_banner.options.image_side.label': 'Picture on the',
  'parts.listing_banner.options.image_side.hint': 'For the picture-beside-the-words layout.',
  'parts.listing_banner.options.image_side.choices.left': 'Left',
  'parts.listing_banner.options.image_side.choices.right': 'Right',
  'parts.listing_banner.options.image_url.label': 'Picture of your own',
  'parts.listing_filters.label': 'Filters',
  'parts.listing_filters.description': 'The shelves as chips, a sidebar or an inline list - or the full filters: price, brand, size, colour and stock, with counts.',
  'parts.listing_filters.options.mode.label': 'Filter by',
  'parts.listing_filters.options.mode.hint': 'The full filters narrow the shelf being browsed, and fold into a drawer on a phone.',
  'parts.listing_filters.options.mode.choices.categories': 'Categories only',
  'parts.listing_filters.options.mode.choices.facets': 'Price, brand, size, colour and stock',
  'parts.listing_filters.options.sidebar_style.label': 'Sidebar rows',
  'parts.listing_filters.options.sidebar_style.hint': 'For a sidebar of categories: words only, or each category with its picture.',
  'parts.listing_filters.options.sidebar_style.choices.text': 'Words only',
  'parts.listing_filters.options.sidebar_style.choices.pictures': 'Picture and name',
  'parts.listing_sort.label': 'Sort',
  'parts.listing_sort.description': 'Newest, cheapest, by name - the same choice search offers.',
  'parts.listing_grid.label': 'Product grid',
  'parts.listing_grid.description': 'The products themselves.',
  'parts.listing_promo_tile.label': 'Promo tile in the grid',
  'parts.listing_promo_tile.description': 'An advert standing among the products on the first page - an offer, a new range, a sale.',
  'parts.listing_promo_tile.options.position.label': 'Place in the grid',
  'parts.listing_promo_tile.options.position.hint': 'Counted from the first product. A page with fewer products leaves it out.',
  'parts.listing_promo_tile.options.span.label': 'Width',
  'parts.listing_promo_tile.options.span.choices.1': 'One product wide',
  'parts.listing_promo_tile.options.span.choices.2': 'Two products wide',
  'parts.listing_promo_tile.options.image_url.label': 'Picture',
  'parts.listing_promo_tile.options.color.label': 'Colour without a picture',
  'parts.listing_promo_tile.options.color.choices.primary': 'Brand colour',
  'parts.listing_promo_tile.options.color.choices.surface': 'Soft tint',
  'parts.listing_promo_tile.options.color.choices.ink': 'Text colour',
  'parts.listing_promo_tile.options.color.choices.accent': 'Highlight colour',
  'parts.listing_promo_tile.options.text.label': 'Short line',
  'parts.listing_promo_tile.options.text.placeholder': 'On your first order',
  'parts.listing_promo_tile.options.eyebrow.label': 'Small line above',
  'parts.listing_promo_tile.options.eyebrow.placeholder': 'Limited time',
  'parts.listing_promo_tile.options.heading.label': 'Heading',
  'parts.listing_promo_tile.options.heading.hint': "Blank shows the shop's own words, in the shopper's language.",
  'parts.listing_promo_tile.options.heading.placeholder': 'New arrivals',
  'parts.listing_promo_tile.options.cta_label.label': 'Button words',
  'parts.listing_promo_tile.options.cta_label.placeholder': 'Shop now',
  'parts.listing_promo_tile.options.href.label': 'Links to',
  'parts.listing_promo_tile.options.href.placeholder': '/products',
  'parts.listing_pagination.label': 'Pages',
  'parts.listing_pagination.description': 'Previous, next, and where the shopper is.',
  'parts.category_heading.label': 'Heading',
  'parts.category_heading.description': 'The words at the top of the shelves.',
  'parts.category_grid.label': 'Category grid',
  'parts.category_grid.description': 'The shelves themselves.',
  'parts.search_heading.label': 'Search heading',
  'parts.search_heading.description': 'The words at the top of the results.',
  'parts.search_count.label': 'Result count',
  'parts.search_count.description': 'How many matches, and what was searched for.',
  'parts.search_facets.label': 'Facet panel',
  'parts.search_facets.description': 'Price, brand, options - what a shopper narrows results by.',
  'parts.search_sort.label': 'Sort',
  'parts.search_sort.description': 'Newest, cheapest, by name.',
  'parts.search_grid.label': 'Results grid',
  'parts.search_grid.description': 'The matches themselves.',
  'parts.search_pagination.label': 'Pages',
  'parts.search_pagination.description': 'Previous, next, and where the shopper is.',
  // --- Ask for changes (AI) ---
  'assist.region': 'Ask for changes',
  'assist.label_section': 'Ask for changes to this section',
  'assist.label_global': 'Ask for changes to your theme',
  'assist.info':
    'Describe what you want in plain words, in English or Hindi - for example "make this banner brighter". The AI changes your draft, nothing goes live, and Undo reverses it. Each request uses one AI draft from your plan.',
  'assist.placeholder': 'Ask for changes…',
  'assist.send': 'Ask',
  'assist.sending': 'Working…',
  'assist.working': 'Changing your draft…',
  'assist.suggestions': 'Suggestions',
  'assist.changed': 'Changed: {summary}',
  'assist.changed_fallback': 'Your draft was updated.',
  'assist.undo_hint': 'Not right? Press Undo.',
  'assist.nothing':
    'That could not be done here. Try naming the section and what should be different, like "make the banner full screen".',
  'assist.stale': 'Your draft changed while the AI was working, so nothing was applied. Please ask again.',
  'assist.error_quota':
    'You have used this month’s AI drafts, so this request could not be made.',
  'assist.error_generic': 'The AI could not be reached. Please try again in a moment.',
  'assist.suggest.hero.brighter': 'Make the banner brighter',
  'assist.suggest.hero.diwali_heading': 'Change the heading to a Diwali offer',
  'assist.suggest.hero.full_screen': 'Make it full screen',
  'assist.suggest.slideshow.slower': 'Change slides more slowly',
  'assist.suggest.slideshow.taller': 'Make the slideshow taller',
  'assist.suggest.featured_products.show_eight': 'Show 8 products instead of 4',
  'assist.suggest.featured_products.three_columns': 'Show 3 products per row',
  'assist.suggest.featured_products.retitle': 'Call it "Bestsellers"',
  'assist.suggest.categories.retitle': 'Call it "Shop by collection"',
  'assist.suggest.categories.four_columns': 'Show 4 categories per row',
  'assist.suggest.banner.diwali': 'Turn this into a Diwali sale message',
  'assist.suggest.banner.free_delivery': 'Say free delivery above ₹499',
  'assist.suggest.text.shorter': 'Make the text shorter',
  'assist.suggest.text.centre': 'Centre the text',
  'assist.suggest.image_with_text.swap_side': 'Put the picture on the other side',
  'assist.suggest.image_with_text.warmer_copy': 'Make the heading warmer and friendlier',
  'assist.suggest.testimonials.retitle': 'Call it "Loved by our customers"',
  'assist.suggest.newsletter.offer': 'Offer 10% off for signing up',
  'assist.suggest.section.stand_out': 'Make this section stand out',
  'assist.suggest.section.hide_mobile': 'Hide this on phones',
  'assist.suggest.section.more_space': 'Add more space around it',
  'assist.suggest.global.warmer': 'Use warmer colours',
  'assist.suggest.global.diwali_strip': 'Add a Diwali offer strip on the home page',
  'assist.suggest.global.bigger_text': 'Make the text a little bigger',
  'assist.suggest.category.feature': 'Feature {category} on the home page',
  'assist.suggest.category.show_here': 'Show {category} here',
  'assist.suggest.category.link_button': 'Point the button to {category}',
  'assist.thread': 'Your conversation with the AI',
  'assist.you_said': 'You asked:',
  'assist.placeholder_follow_up': 'Ask a follow-up, like “make it bigger”…',
  'assist.changes': 'What changed',
  'assist.refused_title': 'What could not be done',
  'assist.pictures': 'Pictures to make',
  'assist.picture_idea': 'A picture would help here: {prompt}',
  'assist.make_picture': 'Make this picture with AI',
  'assist.preview_hint': 'This is showing in the preview. Nothing is changed until you keep it.',
  'assist.keep': 'Keep',
  'assist.discard': 'Discard',
  'assist.discarded': 'Discarded. Your draft is as it was.',
  // --- Store health ---
  'health.title': 'Store health',
  'health.info':
    'Things a shopper might run into, found in your draft. Fix buttons take you straight to the right place. Tips make the shop look more finished.',
  'health.count': '{count} to fix',
  'health.badge': '{count} things to fix in your shop',
  'health.all_good': 'Everything looks good.',
  'health.severity_fix': 'Needs fixing',
  'health.severity_tip': 'Tip',
  'health.fix': 'Fix',
  'health.show': 'Show me',
  'health.contrast_text_background':
    'Your text is hard to read on the background colour (contrast {ratio}:1, needs 4.5:1).',
  'health.contrast_text_surface':
    'Your text is hard to read on the card colour (contrast {ratio}:1, needs 4.5:1).',
  'health.contrast_button':
    'Button text is hard to read on your brand colour (contrast {ratio}:1, needs 4.5:1).',
  'health.image_too_small':
    'A picture in {section} is {width}×{height} pixels and will look blurry. Use one at least {minWidth}×{minHeight}.',
  'health.logo_too_small':
    'Your logo is {width}×{height} pixels and may look blurry. Use one at least {minWidth}×{minHeight}.',
  'health.heading_empty': '{section} has no heading. A short title tells shoppers what they are looking at.',
  'health.link_broken': 'A button in {section} leads to a page that does not exist.',
  'health.link_missing': 'A button in {section} does not go anywhere yet.',
  'health.placeholder_content':
    '{section} is still showing sample content. Shoppers will not see it until you add your own.',
  'health.featured_empty_category': 'The product grid shows {category}, which has no products yet.',
  'health.featured_missing_category': 'The product grid shows a category that no longer exists.',
  'health.featured_no_products': 'The product grid has nothing to show until you add products.',
  'health.no_logo': 'Add your logo so shoppers recognise your shop.',
  'health.banner_too_long':
    'Your announcement is {length} characters and will wrap on a phone. Keep it under {max}.',
  // --- Colours from your logo ---
  'logo_palette.title': 'From your logo',
  'logo_palette.info':
    'Colours picked from your logo, adjusted so text and buttons stay easy to read. Applying them changes your five theme colours at once, and Undo puts them back.',
  'logo_palette.loading': 'Reading the colours in your logo…',
  'logo_palette.failed': 'Your logo could not be read. Try again after uploading it once more.',
  'logo_palette.no_colour': 'Your logo is black and white, so there is no brand colour to use.',
  'logo_palette.apply': 'Use these colours',
  'logo_palette.applied': 'In use',
  // --- Plugins ---
  'plugins.title': 'Plugins',
  'plugins.open_hint': 'Add features like a slide-in cart, on any theme',
  'plugins.intro':
    'Plugins add a feature to your whole shop, whatever theme you use. Changes show in the preview and go live when you publish.',
  'plugins.install': 'Install',
  'plugins.install_named': 'Install {name}',
  'plugins.installing': 'Installing…',
  'plugins.installed': 'Installed',
  'plugins.included': 'Included with this theme.',
  'plugins.remove': 'Remove',
  'plugins.remove_named': 'Remove {name}',
  'plugins.removing': 'Removing…',
  'plugins.quick_cart.name': 'Quick cart',
  'plugins.quick_cart.description':
    'A cart that slides in from the right, so shoppers can check their cart and keep browsing.',
  'plugins.quick_cart.open_on_add': 'Open it after "Add to cart"',
  'plugins.quick_cart.open_on_add_hint': 'When off, only the cart icon opens it.',
  'plugins.quick_cart.free_shipping_bar': 'Show free delivery progress',
  'plugins.quick_cart.free_shipping_bar_hint': 'Only appears when you have set a free delivery amount.',
  'plugins.quick_cart.recommendations': 'Show recommended products',
  'plugins.pages.all': 'Every page',
  'plugins.pages.home': 'Home page',
  'plugins.pages.product': 'Product pages',
  'plugins.pages.collection': 'Product lists and categories',
  'plugins.pages.cart': 'Cart',
  'plugins.pages.none': 'Pick at least one page, or the popup will not show anywhere.',
  'plugins.promo_popup.name': 'Promo popup',
  'plugins.promo_popup.description':
    'A popup with your offer and an email sign-up, shown a few seconds after a shopper arrives.',
  'plugins.promo_popup.show_on': 'Show on',
  'plugins.promo_popup.delay_seconds': 'Wait before showing (seconds)',
  'plugins.promo_popup.delay_seconds_hint': 'Shown once per visit. Never on checkout.',
  'plugins.promo_popup.eyebrow': 'Small heading',
  'plugins.promo_popup.headline': 'Headline',
  'plugins.promo_popup.subtitle': 'Text under the headline',
  'plugins.promo_popup.button_label': 'Button text',
  'plugins.promo_popup.image_url': 'Picture',
  'plugins.promo_popup.panel_color': 'Background colour',
  'plugins.promo_popup.panel_color_hint': "Leave empty to use your theme's main colour.",
  'plugins.promo_popup.collect_name': 'Ask for their name too',
  'plugins.search_suggest.name': 'Search suggestions',
  'plugins.search_suggest.description':
    'Shows products and categories while shoppers type, right from the search icon.',
  'plugins.search_suggest.style': 'How it opens',
  'plugins.search_suggest.style_overlay': 'Full screen',
  'plugins.search_suggest.style_dropdown': 'Dropdown under the icon',
  'plugins.search_suggest.show_products': 'Suggest products',
  'plugins.search_suggest.show_categories': 'Suggest categories',
  'plugins.search_suggest.max_results': 'Products to suggest',
  'plugins.search_suggest.max_results_hint': 'Between 3 and 10.',
  'plugins.wishlist.name': 'Wishlist',
  'plugins.wishlist.description':
    'Lets shoppers tap a heart to save products for later and see them all on one page.',
  'plugins.wishlist.show_in_header': 'Heart with a count in the header',
  'plugins.wishlist.show_on_cards': 'Heart on product cards',
  'plugins.wishlist.show_on_product': 'Heart on the product page',
  'plugins.color_mode.name': 'Light and dark mode',
  'plugins.color_mode.description': 'Gives shoppers a sun and moon button to switch your shop between light and dark colours.',
  'plugins.color_mode.default_mode': 'What shoppers see first',
  'plugins.color_mode.default_mode_hint': 'Once a shopper picks a mode, their device remembers it.',
  'plugins.color_mode.default_mode_theme': "Your theme's own colours",
  'plugins.color_mode.default_mode_system': "The shopper's device setting",
  'plugins.color_mode.show_toggle': 'Light/dark button in the header',
  'plugins.color_mode.alternate_primary': 'Other mode: brand colour',
  'plugins.color_mode.alternate_primary_hint': "Leave any of these empty and we work it out from your theme's colours.",
  'plugins.color_mode.alternate_background': 'Other mode: background',
  'plugins.color_mode.alternate_surface': 'Other mode: cards and panels',
  'plugins.color_mode.alternate_text': 'Other mode: text',
  'plugins.color_mode.alternate_muted': 'Other mode: quiet text',
  'plugins.app_tab_bar.name': 'App bar on phones',
  'plugins.app_tab_bar.description':
    'Puts Home, Categories, Search, Cart and Account in a bar at the bottom of the screen on phones, like a shopping app.',
  'plugins.app_tab_bar.show_labels': 'Names under the icons',
  'cards.title': 'Product cards',
  'cards.hint': 'How every product card in your shop looks and behaves. All off to start.',
  'cards.hover_image': 'Show the second photo on hover',
  'cards.badges': 'Badges',
  'cards.badge_sale': 'Sale badge',
  'cards.badge_new': 'New badge',
  'cards.badge_new_days': 'Counts as new for (days)',
  'cards.badge_bestseller': 'Bestseller badge',
  'cards.badge_sold_out': 'Sold out badge',
  'cards.badge_style': 'Badge shape',
  'cards.badge_style.pill': 'Pill',
  'cards.badge_style.ribbon': 'Ribbon',
  'cards.badge_style.corner': 'Corner tab',
  'cards.swatches': 'Colour dots',
  'cards.quick_add': 'Quick add',
  'cards.quick_add.off': 'Off',
  'cards.quick_add.button': 'Button on the photo',
  'cards.quick_add.icon': 'Round + icon',
  'sections.pricing_plans.label': 'Pricing plans',
  'sections.pricing_plans.description': 'Two to four plans side by side - memberships, packages, diet or coaching plans - each with a price and a button.',
  'sections.pricing_plans.block': 'Plan',
  'sections.product_spotlight.label': 'Product spotlight',
  'sections.product_spotlight.description': 'One product shown large, with its price and an add-to-cart button beside a big picture.',
  'sections.product_showcase.label': 'Product showcase',
  'sections.product_showcase.description': 'A dark band with a big product scene, a heading and a button, and a small product card on the picture.',
  'sections.bmi_calculator.label': 'BMI calculator',
  'sections.bmi_calculator.description': 'A height and weight form that works out BMI, with your own line under each result and a photo beside it.',
  'sections.marquee.label': 'Scrolling ribbon',
  'sections.marquee.description': 'A thin band of short benefits - free shipping, lab tested - scrolling sideways without end.',
  'sections.marquee.block': 'Item',
  // --- People: the team section, profiles and booking by person ---
  'team.intro': 'Lists the people you show on the Team screen - their photos, roles and bios are kept there, not here.',
  'team.manage': 'Manage your team',
  'team.columns': 'People per row',
  'team.card_style': 'Card style',
  'team.card_style_choice.portrait': 'Portrait',
  'team.card_style_choice.round': 'Round photo',
  'team.card_style_choice.overlay': 'Name over photo',
  'team.limit': 'How many to show',
  'team.limit_all': 'Everyone',
  'team.show_bio': 'Show the short bio',
  'team.show_search': 'Show a search box',
  'team.filter_layout': 'Filter position',
  'team.filter_layout_choice.top': 'Bar above the team',
  'team.filter_layout_choice.sidebar': 'Column on the left',
  'team.show_availability': 'Show when each person is free',
  'team.show_profile_button': 'Show a "View profile" button',
  'team.filters': 'Filters over the team',
  'team.filters_hint': 'Each filter appears only when your people have that detail filled in on the Team screen. They show in the order you turn them on.',
  'team.filter_choice.speciality': 'Speciality',
  'team.filter_choice.availability': 'Availability',
  'team.filter_choice.visit_format': 'Visit type',
  'team.filter_choice.experience': 'Experience',
  'team.filter_choice.gender': 'Gender',
  'team.filter_choice.language': 'Language',
  'team.show_book_button': 'Show a Book button',
  'team.book_href': 'Book button goes to',
  'team.profile.intro': 'Each person gets a page at /team/their-name. Their details come from the Team screen; choose here what the page shows.',
  'team.profile.show_qualifications': 'Show qualifications',
  'team.profile.show_hours': 'Show working hours',
  'team.profile.show_services': 'Show the services they offer',
  'team.profile.layout': 'Page layout',
  'team.profile.layout_choice.theme': 'Theme\'s choice',
  'team.profile.layout_choice.stacked': 'One section under another',
  'team.profile.layout_choice.tabs': 'Tabs',
  'team.profile.layout_choice.sidebar': 'Booking card beside the profile',
  'team.profile.show_experience': 'Show years of experience',
  'team.profile.show_languages': 'Show languages spoken',
  'team.profile.show_education': 'Show education',
  'team.profile.show_career': 'Show career',
  'team.profile.show_booking_calendar': 'Show a booking calendar',
  'team.staff_group': 'Who the appointment is with',
  'team.staff_group_hint': 'Book with a particular person - a doctor, a stylist - instead of just a time.',
  'team.staff_mode': 'Book with',
  'team.staff_mode_choice.none': 'Nobody in particular',
  'team.staff_mode_choice.choose': 'The shopper chooses a person',
  'team.staff_mode_choice.fixed': 'Always the same person',
  'team.staff_member': 'Person',
  'team.staff_member_placeholder': 'Pick a person',
  'team.staff_member_hidden': 'This person is hidden on the Team screen, so nobody can book them until you show them again.',
  'team.allow_any_staff': 'Offer "Any available"',
  'team.staff_label': 'Heading over the people',
  'team.staff_label_placeholder': 'Choose a team member',
  'team.no_people': 'You have not added anyone yet. Add people on the Team screen and they appear here.',
  'team.capacity_note': 'Each person takes one appointment at a time, on their own hours, so "How many at once" is not used.',
  'team.location': 'Where it happens',
  'team.location_choice.place': 'At your place',
  'team.location_choice.online': 'Online',
  'team.location_choice.address': "At the customer's address",
  'team.location_note': 'Note for the customer',
  'team.location_note_placeholder.place': 'e.g. Parking at the back',
  'team.location_note_placeholder.online': "e.g. We'll email you a meeting link",
  'team.location_note_placeholder.address': 'e.g. We cover all of Pune',
  'team.tips.title': 'The heading over the team. Leave it blank for no heading.',
  'team.tips.subtitle': 'One line under the heading, such as what your team is known for.',
  'team.tips.columns': 'How many people stand side by side on a computer. Phones always show one.',
  'team.tips.card_style': 'Portrait shows a tall photo with the words under it. Round photo suits a small team. Name over photo suits strong pictures.',
  'team.tips.limit': 'Show only the first few people, in the order set on the Team screen.',
  'team.tips.show_bio': 'The one-line bio from the Team screen, under each name.',
  'team.tips.show_search': 'A box over the team where customers type a name, speciality or role to find someone.',
  'team.tips.filter_layout': 'Where the search box and filters sit. "Bar above the team" is a row of buttons over the cards. "Column on the left" puts them beside the cards on computers, with tick boxes so customers can pick several options at once - good for a clinic with many doctors. On phones both fold behind a "Filters" button.',
  'team.tips.show_availability': 'Adds a small line to each card: "Available today", or the next day with a free time. Nothing shows for a person whose next free day is not known.',
  'team.tips.show_profile_button': 'Adds a "View profile" button beside the book button that opens the person\'s own page. Their name already links there; the button makes it obvious.',
  'team.tips.filter_speciality': 'One button per speciality. Shown when your people have two or more specialities.',
  'team.tips.filter_availability': '"Available today", "This week" and a working-day choice, from each person\'s hours and free times.',
  'team.tips.filter_visit_format': 'In person, online or home visit - from the visit types set for each person.',
  'team.tips.filter_experience': '"5+ years", "10+ years" and "20+ years", from each person\'s years of experience.',
  'team.tips.filter_gender': 'Female and male, only for people whose gender is filled in. Leave it off unless customers ask for it.',
  'team.tips.filter_language': 'One button per language your people speak.',
  'team.tips.show_book_button': "A button that opens your booking page with this person already picked.",
  'team.tips.book_label': 'The words on the Book button.',
  'team.tips.book_href': 'The page with your bookings section. The person is added to the link so the booking starts with them.',
  'team.tips.profile_show_qualifications': 'Degrees and certificates, such as "MBBS, MD".',
  'team.tips.profile_show_hours': "The days and times this person works - their own hours, or this booking section's when they have none.",
  'team.tips.profile_show_services': 'The services this person offers, from your bookings section.',
  'team.tips.profile_layout': 'One section under another shows everything on one long page. Tabs puts About, Education & career, Services, Availability and Book behind tabs under the person\'s photo and name. Booking card beside the profile shows everything one under another with a calendar for this person that stays beside it as customers scroll; for someone no bookings section can book, the page shows one section under another instead.',
  'team.tips.profile_show_experience': 'For example "12 years experience", next to their name.',
  'team.tips.profile_show_languages': 'The languages they speak, as small labels under their name.',
  'team.tips.profile_show_education': 'Their degrees and courses as a timeline, from the Team screen.',
  'team.tips.profile_show_career': 'Where they have worked as a timeline, from the Team screen.',
  'team.tips.profile_show_booking_calendar': 'A calendar on their page to book them directly. Needs a bookings section set to book with a person who offers at least one service there.',
  'team.tips.staff_mode': 'Nobody in particular takes bookings as before. The shopper chooses lets customers pick a person (or anyone free). Always the same person books everything with one person.',
  'team.tips.staff_member': 'Every booking from this section is with this person, on their hours.',
  'team.tips.allow_any_staff': 'Adds an "Any available" choice; you pick who takes the booking from whoever is free.',
  'team.tips.staff_label': 'Leave blank to say "Choose a" with your word for a team member, such as "Choose a doctor".',
  'team.tips.location': 'At your place is the default. Online shows "Online" with your note. At the customer\'s address makes the booking form ask for their address.',
  'team.tips.location_note': 'A short line customers read before booking, such as how they will get the meeting link.',
};

export default themeEditor;
